import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { fullSize } from '../../../Constants';
import { IAppReduxStore } from '../../../redux/store';
import AdditionalDocsTreeView from '../AdditionalDocsTreeView/AdditionalDocsTreeView';
import CommunicationDocsTreeView from '../AdditionalDocsTreeView/CommunicationDocsTreeView';
import LoadingData from './Components/LoadingData';
import PlaceholderCard from './Components/PlaceholderCard';

/**
 * Sidepanel that shows details on the additional documents for a given document.
 */
export default () => {
    /** Configure component translation. */
    const { t } = useTranslation('translations', { keyPrefix: 'sidepanel' });

    /** Get relevant values from Redux store. */
    const universalId = useSelector((store: IAppReduxStore) => store.projectSidepanel.targetDocId);
    const noteId = useSelector((store: IAppReduxStore) => store.projectSidepanel.targetNoteId);
    const { documents, communicationDocuments } = useSelector(
        (store: IAppReduxStore) => store.projectAdditionalDocs,
    );
    const { data: additionalDocs, loading } = documents;

    const hasDocs = additionalDocs?.[noteId]?.length > 0;

    return (
        <Stack sx={{ px: 1, pb: 1, flexGrow: 4 }}>
            <Typography
                variant='h6'
                sx={{
                    fontSize: 16,
                    py: 1,
                }}
            >
                {t('documents')}
            </Typography>
            {loading && <LoadingData />}
            {!loading && !hasDocs && (
                <PlaceholderCard translationKey='NoAdditionalDocsPlaceholder' />
            )}
            <Stack
                sx={{
                    flexGrow: 4,
                    overflow: 'hidden',
                    position: 'relative',
                }}
            >
                <Stack
                    sx={{
                        position: 'absolute',
                        ...fullSize,
                    }}
                >
                    <AdditionalDocsTreeView
                        universalId={universalId}
                        noteId={noteId}
                        disableClick={true}
                        small
                    />
                </Stack>
            </Stack>

            {communicationDocuments?.[noteId]?.length > 0 && (
                <>
                    <Typography
                        variant='h6'
                        sx={{
                            fontSize: 16,
                            py: 1,
                        }}
                    >
                        {t('communication')}
                    </Typography>
                    <Stack
                        sx={{
                            flexGrow: 4,
                            overflow: 'hidden',
                            position: 'relative',
                        }}
                    >
                        <Stack
                            sx={{
                                position: 'absolute',
                                ...fullSize,
                            }}
                        >
                            <CommunicationDocsTreeView noteId={noteId} />
                        </Stack>
                    </Stack>
                </>
            )}
        </Stack>
    );
};
